import React from "react";
import ReactDOM from "react-dom";

import { observer, inject, Provider } from "mobx-react";

import { extendObservable } from 'mobx';


@inject('core')
@observer
export default class Needs extends React.Component {
	
	constructor(props) {
		super(props)
		this.changeNeeds = this.changeNeeds.bind(this)
	}
	
	componentDidMount() {
		const { core } = this.props
	}
	
	changeNeeds(product_id) {
		const { core } = this.props

		var needs = window.prompt('Needed:', core.products.find( p => p.product_id == product_id ).needs)
		
		if ((typeof needs !== 'undefined') && (needs !== null)) {
			core.action({
				op:'setNeeds', 
				product_id, 
				needs: needs
			})
		}
	}

	render() {
		const { core, product_id } = this.props
		
		const product = core.products.find(p => p.product_id == product_id)
		if (typeof product === 'undefined') {
			return <div>Unknown Product</div>
		}
		
		return <span className="needs-button clickable" onClick={() => this.changeNeeds(product.product_id)}>
			 {product.needs ? product.needs : '\u00A0'}
		</span>
	}
	
}


